import { useState } from 'react';
import { copyText, shareLink, xIntentUrl } from '../lib/share.ts';

/** The link plus Copy and Share. `dark` for navy grounds; `compact` drops the Post on X row. */
export function ShareBar({ url, compact = false, dark = false, label = 'Your stream link' }: { url: string; compact?: boolean; dark?: boolean; label?: string }) {
  const [note, setNote] = useState<string | null>(null);
  const flash = (t: string) => {
    setNote(t);
    setTimeout(() => setNote(null), 1800);
  };
  const display = url.replace(/^https?:\/\//, '');
  return (
    <div className="w-full">
      <input
        readOnly
        value={display}
        aria-label={label}
        className={`h-12 w-full truncate rounded-xl px-3.5 font-mono text-[15px] outline-none focus:ring-2 focus:ring-race ${dark ? 'bg-navy-800 text-white' : 'bg-mist text-navy'}`}
        onFocus={(e) => e.currentTarget.select()}
      />
      <div className="mt-2 grid grid-cols-2 gap-2">
        <button
          type="button"
          className={`h-12 rounded-xl border-2 text-[15px] font-extrabold ${dark ? 'border-line-dark text-white hover:bg-white/10' : 'border-line bg-white text-navy hover:bg-mist'}`}
          onClick={async () => flash((await copyText(url)) === 'copied' ? 'Link copied' : 'Copy failed')}
        >
          {note === 'Link copied' ? 'Copied ✓' : 'Copy link'}
        </button>
        <button
          type="button"
          className={`h-12 rounded-xl text-[15px] font-extrabold ${dark ? 'bg-white text-navy hover:bg-mist' : 'bg-navy text-white hover:bg-navy-700'}`}
          onClick={async () => {
            const r = await shareLink(url);
            if (r === 'copied') flash('Link copied');
          }}
        >
          Share…
        </button>
      </div>
      {!compact && (
        <a
          className={`mt-3 inline-block text-sm font-bold underline-offset-2 hover:underline ${dark ? 'text-muted-dark' : 'text-muted'}`}
          href={xIntentUrl(url)}
          target="_blank"
          rel="noreferrer"
        >
          Post it on X
        </a>
      )}
      <span role="status" aria-live="polite" className="sr-only">
        {note}
      </span>
    </div>
  );
}
